// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__36Znb","size-18":"Text_size-18__3ivw4","level-1":"Text_level-1__1C-9w","level-2":"Text_level-2__3vuu-","bold":"Text_bold__3kKTm"};